import React from 'react';
import { motion } from 'framer-motion';
import { AwardIcon, CheckIcon, XIcon } from 'lucide-react';
import { systemNegatives, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="bg-stage-warm contour-lines py-16 sm:py-20" aria-labelledby="system-title" data-id="element-233" data-mp="3bhljv43cc8l2">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-234" data-mp="36j0kt7ztruy7">
        <span className="inline-flex items-center gap-2 rounded-md border-2 border-goldDeep bg-gold px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-forestDeep" data-id="element-235" data-mp="31kgz98p58l6d">
          <AwardIcon className="h-4 w-4" aria-hidden="true" data-id="element-236" data-mp="2ws5vtvv72h92" /> The most comprehensive surveying teaching system in the
          world
        </span>
        <h2 id="system-title" className="mx-auto mt-5 max-w-3xl text-balance text-3xl font-extrabold text-forestDeep sm:text-4xl" data-id="element-237" data-mp="2nudfqphnf5km">
          Surveying &amp; Topography Teacher Ready
        </h2>
        <p className="mt-3 font-semibold text-earth" data-id="element-238" data-mp="2dw614dau0zls">
          {totalVolumes} volumes · {totalBonuses} exclusive bonuses · Everything you need to teach surveying with
          confidence.
        </p>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 text-left sm:grid-cols-3" data-id="element-239" data-mp="18qzp9nbd6yhn">
          {systemNegatives.map(item => <motion.li key={item} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-lg border border-line bg-white p-4 text-sm font-semibold text-inkSoft shadow-card" data-id="element-240" data-mp="u2v5sh4hmixt">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger" aria-hidden="true" data-id="element-241" data-mp="1cr9xz7qjk307" />
              {item}
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-8 flex max-w-3xl items-start gap-3 rounded-xl border-l-4 border-gold bg-forest p-6 text-left text-lg font-bold leading-relaxed text-cream" data-id="element-242" data-mp="1c3cpsipyaep">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-goldBright" aria-hidden="true" data-id="element-243" data-mp="28y4ruba8e6yq" />
          It's a complete system so you can enter the classroom with confidence and deliver lessons that truly teach how
          to measure, calculate and represent the terrain accurately.
        </p>
      </div>
    </section>;
}